import { render, staticRenderFns } from "./DiscardItemModal.vue?vue&type=template&id=29ecb0e6&scoped=true&"
import script from "./DiscardItemModal.vue?vue&type=script&lang=js&"
export * from "./DiscardItemModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscardItemModal.vue?vue&type=style&index=0&id=29ecb0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecb0e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ecb0e6')) {
      api.createRecord('29ecb0e6', component.options)
    } else {
      api.reload('29ecb0e6', component.options)
    }
    module.hot.accept("./DiscardItemModal.vue?vue&type=template&id=29ecb0e6&scoped=true&", function () {
      api.rerender('29ecb0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/components/DiscardItemModal.vue"
export default component.exports